import { SET_GLOBAL_ACCOUNT_V2_SUMMARY } from './globalAccountV2SummaryActionTypes';

const initialState = {
  globalAccountV2Summary: null,
};

export const globalAccountV2SummaryState = (state = initialState, action) => {
  const updatedState = { ...state };

  switch (action.type) {
    case SET_GLOBAL_ACCOUNT_V2_SUMMARY:
      updatedState.globalAccountV2Summary = action.payload;
      return updatedState;
    default:
      return state;
  }
};
